import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageMetaSchema } from '../pagination';
import { JobSchema } from './shapes';

export const JOB_RESULTS = ['success', 'failure', 'cancelled', 'running'] as const;
export const JobResultSchema = z.enum(JOB_RESULTS);
export type JobResult = z.infer<typeof JobResultSchema>;

/** History: jobs that started (running or finished), newest start first. */
export const ListJobsQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  cursor: z.string().optional(),
  machineId: z.string().uuid().optional(),
  runner: z.string().min(1).optional(),
  repo: z.string().min(1).optional(),
  result: JobResultSchema.optional(),
  /** Window on startedAt. */
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
});
export type ListJobsQuery = z.infer<typeof ListJobsQuerySchema>;

export const listRunnerJobs = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/jobs',
  params: z.object({}),
  query: ListJobsQuerySchema,
  body: z.undefined(),
  response: z.object({ data: z.array(JobSchema), meta: PageMetaSchema }),
});
